import { ERROR_TYPES } from '../../../components/partials/multiple-products-selection-error/multiple-products-selection-error';
export function validateColorVariant({
  totalAmountForColorVariant,
  parentId,
  colorVariantId,
  variantCapMap,
  selectedQuantities,
  isReserve,
  isSelected,
  isOneProduct
}) {
  const key = colorVariantId || parentId;
  const cap = variantCapMap === null || variantCapMap === void 0 ? void 0 : variantCapMap[key];
  const errors = [];
  if (isSelected && totalAmountForColorVariant === 0) {
    errors.push({
      type: ERROR_TYPES.ZERO_QUANTITY_SELECTED,
      data: {}
    });
  }
  if (isReserve) {
    const lowStockErrors = selectedQuantities.reduce((result, selectedQuantityObject) => {
      if (selectedQuantityObject.amount > selectedQuantityObject.availableQuantity) {
        result.push({
          type: ERROR_TYPES.MORE_THAN_AVAILABLE_FOR_VARIANT,
          data: {
            available: selectedQuantityObject.availableQuantity
          }
        });
      }
      return result;
    }, []);
    errors.push(...lowStockErrors);
  }
  if (!isOneProduct && cap && totalAmountForColorVariant > cap) {
    errors.push({
      type: ERROR_TYPES.MORE_THAN_CAP,
      data: {
        cap,
        totalAmountForColorVariant
      }
    });
  }
  if (!errors.length) {
    return null;
  }
  return errors;
}